'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { getCompareRoute } from 'FormsCommonComponents/lib/RouteGenerators';
import { trackDashboardInteraction } from 'FormsUI/utils/TrackingUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const CompareFormsAllowed = ({
  formGuids = [],
  disabled = false,
  trackingOptions = {}
}) => {
  const href = getCompareRoute(formGuids);
  const onClick = () => trackDashboardInteraction('form-action-go-to-comparison-tool', trackingOptions);
  return /*#__PURE__*/_jsx(Link, {
    "data-test-id": "compare-forms-allowed-href",
    disabled: disabled,
    href: href,
    onClick: onClick,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: 'dashboard.table.tableActions.compareForms'
    })
  });
};
export default CompareFormsAllowed;